import Login from "views/Authentication/Login";
import LoginOtp from "views/Authentication/LoginOtp";
import DefaultLayout from "layouts/DefaultLayout";
import dashboardRoutes from "configs/dashboardRoutes";
import { URLS } from "configs/constants";
import FirstTimePassword from "views/Authentication/FirstTimePassword";
import LoginPassword from "views/Authentication/LoginPassword";
// import Profile from "views/UserProfile/Profile";
import UserProfile from "views/UserProfile/UserProfile";
import UserChangePassword from "views/User/UserChangePassword";
import CreateFirstTimePassword from "views/Authentication/CreateFirstTimePassword";
import UserProfileLayout from "layouts/UserProfileLayout";

/**
 * Please see the docstring of dashboardRoutes to understand the route pattern clearly
 */
const route = [
  {
    path: URLS.LOGIN,
    name: "Login",
    component: Login,
    layout: DefaultLayout,
    protected: false,
    exact: true,
  },
  {
    path: URLS.LOGIN_OTP,
    name: "LoginOtp",
    component: LoginOtp,
    layout: DefaultLayout,
    protected: false,
    exact: true,
  },
  {
    path: URLS.LOGIN_FIRST_TIME_PASSWORD,
    name: "FirstTimePassword",
    component: FirstTimePassword,
    layout: DefaultLayout,
    protected: false,
    exact: true,
  },
  {
    path: URLS.CREATE_FIRST_TIME_PASSWORD + "/:employee_id",
    name: "CreateFirstTimePassword",
    component: CreateFirstTimePassword,
    layout: DefaultLayout,
    protected: false,
    exact: true,
  },
  {
    path: URLS.LOGIN_PASSWORD,
    name: "LoginPassword",
    component: LoginPassword,
    layout: DefaultLayout,
    protected: false,
    exact: true,
  },
  {
    path: "/profile",
    name: "Profile",
    component: UserProfile,
    layout: UserProfileLayout,
    protected: false,
    exact: true,
  },
  {
    path: "/password-update",
    name: "Change Pasword",
    component: UserChangePassword,
    layout: DefaultLayout,
    protected: false,
    exact: true,
  },
];

export default route.concat(dashboardRoutes);
